export const DASHBOARD_API_VERSION = '1.0';
export const DASHBOARD_API_ROOT = '/dashboard/v1';

export const DASHBOARD_SOURCE = Object.freeze({
  SYSTEM_DEFAULT: 'system_default',
  CUSTOMER: 'customer'
});

export const DASHBOARD_STATUS = Object.freeze({
  DRAFT: 'draft',
  PUBLISHED: 'published',
  ARCHIVED: 'archived'
});

export const DASHBOARD_ASSIGNMENT_SCOPE = Object.freeze({
  ENTITY: 'entity',
  INDUSTRY_TYPE: 'industry_type'
});

export const DASHBOARD_VERSION_STATUS = Object.freeze({
  DRAFT: 'draft',
  PUBLISHED: 'published',
  SUPERSEDED: 'superseded'
});

export const DASHBOARD_VALUE_TYPE = Object.freeze({
  PERCENTAGE: 'percentage',
  INTEGER: 'integer',
  DECIMAL: 'decimal'
});

export const DASHBOARD_AGGREGATION = Object.freeze({
  AVERAGE: 'average',
  SUM: 'sum',
  LATEST: 'latest',
  MINIMUM: 'minimum',
  MAXIMUM: 'maximum'
});

export const DASHBOARD_APPROVAL_MODE = Object.freeze({
  REQUIRED: 'required',
  NOT_REQUIRED: 'not_required'
});

export const DASHBOARD_METRIC_STATUS = Object.freeze({
  ACTIVE: 'active',
  ARCHIVED: 'archived'
});

export const DASHBOARD_VISUALIZATION_TYPE = Object.freeze({
  LINE: 'line',
  BAR: 'bar'
});

export const DASHBOARD_Y_AXIS = Object.freeze({
  LEFT: 'left',
  RIGHT: 'right'
});

export const DASHBOARD_WIDGET_TYPE = Object.freeze({
  NUMERIC: 'numeric',
  PROGRESS: 'progress',
  PIE: 'pie',
  DOUGHNUT: 'doughnut'
});

export const DASHBOARD_WIDGET_TARGET_MODE = Object.freeze({
  METRIC_MAXIMUM: 'metric_maximum',
  CUSTOM: 'custom'
});

export const DASHBOARD_METRIC_VALUE_STATUS = Object.freeze({
  PENDING_APPROVAL: 'pending_approval',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  SUPERSEDED: 'superseded',
  DELETED: 'deleted'
});

export const DASHBOARD_SUBMISSION_STATUS = Object.freeze({
  APPROVED: 'approved',
  PENDING_APPROVAL: 'pending_approval',
  PARTIALLY_APPROVED: 'partially_approved',
  REJECTED: 'rejected',
  DELETED: 'deleted'
});

export const DASHBOARD_DATA_STATE = Object.freeze({
  AVAILABLE: 'available',
  PARTIAL_DATA: 'partial_data',
  NO_DATA: 'no_data'
});

export const DASHBOARD_FEEDBACK_STATUS = Object.freeze({
  OPEN: 'open',
  IN_PROGRESS: 'in_progress',
  RESOLVED: 'resolved',
  NO_ACTION: 'no_action',
  REOPENED: 'reopened',
  DELETED: 'deleted'
});

export const DASHBOARD_FEEDBACK_CATEGORIES = Object.freeze([
  'service',
  'staff',
  'facilities',
  'safety',
  'compliance',
  'compliment',
  'complaint',
  'other'
]);

export const DASHBOARD_PERMISSIONS = Object.freeze({
  VIEW: 'dashboard.view',
  PUBLISH: 'dashboard.publish',
  IMPORT: 'dashboard.import',
  DATA_VIEW: 'dashboard.data.view',
  DATA_UPDATE: 'dashboard.data.update',
  DATA_REMOVE: 'dashboard.data.remove',
  TEMPLATE_VIEW: 'settings.templates.view',
  TEMPLATE_CREATE: 'settings.templates.create',
  TEMPLATE_UPDATE: 'settings.templates.update',
  TEMPLATE_REMOVE: 'settings.templates.remove',
  APPROVALS_VIEW: 'approvals.view',
  APPROVALS_REVIEW: 'approvals.review'
});

export const DASHBOARD_TAG_TYPES = Object.freeze([
  'DashboardEffective',
  'DashboardTemplate',
  'DashboardAssignment',
  'DashboardData',
  'DashboardSubmission',
  'DashboardReview',
  'DashboardFeedback'
]);
